import { getLogger } from '@signalwire/core';
import { getUserMedia as _getUserMedia } from './getUserMedia';
import { assureDeviceId } from './deviceHelpers';
import { sdpHasAudio, sdpHasVideo } from './sdpHelpers';
// FIXME: Remove and use getUserMedia directly
export const getUserMedia = (constraints) => {
    getLogger().info('RTCService.getUserMedia', constraints);
    const { audio, video } = constraints;
    if (!audio && !video) {
        return;
    }
    return _getUserMedia(constraints);
};
const _shouldNegotiateVideo = (options) => {
    var _a;
    return (((_a = options.negotiateVideo) !== null && _a !== void 0 ? _a : true) &&
        (!options.remoteSdp || sdpHasVideo(options.remoteSdp)));
};
const _shouldNegotiateAudio = (options) => {
    var _a;
    return (((_a = options.negotiateAudio) !== null && _a !== void 0 ? _a : true) &&
        (!options.remoteSdp || sdpHasAudio(options.remoteSdp)));
};
const _getVideoConstraints = (options) => {
    var _a;
    return _shouldNegotiateVideo(options)
        ? (_a = options.video) !== null && _a !== void 0 ? _a : !!options.camId
        : false;
};
const _getAudioConstraints = (options) => {
    var _a;
    return _shouldNegotiateAudio(options) ? (_a = options.audio) !== null && _a !== void 0 ? _a : true : false;
};
export const getMediaConstraints = async (options) => {
    let audio = _getAudioConstraints(options);
    const { micLabel = '', micId } = options;
    if (micId && audio) {
        const newMicId = await assureDeviceId(micId, micLabel, 'microphone').catch((_error) => null);
        if (newMicId) {
            if (typeof audio === 'boolean') {
                audio = {};
            }
            audio.deviceId = { exact: newMicId };
        }
    }
    let video = _getVideoConstraints(options);
    const { camLabel = '', camId } = options;
    if (camId && video) {
        const newCamId = await assureDeviceId(camId, camLabel, 'camera').catch((_error) => null);
        if (newCamId) {
            if (typeof video === 'boolean') {
                video = {};
            }
            video.deviceId = { exact: newCamId };
        }
    }
    return { audio, video };
};
export const filterIceServers = (servers, options) => {
    const { disableUdpIceServers = false } = options;
    const filterOutUdpUrls = (urls) => {
        const transportParam = 'transport=udp';
        if (Array.isArray(urls)) {
            return urls.filter((url) => !url.includes(transportParam));
        }
        return urls.includes(transportParam) ? '' : urls;
    };
    return servers.map((server) => (Object.assign(Object.assign({}, server), { urls: disableUdpIceServers ? filterOutUdpUrls(server.urls) : server.urls })));
};
//# sourceMappingURL=helpers.js.map